import { useState } from "react";
import { Link } from "react-router-dom";
import { blogPosts, blogCategories } from "@/mocks/blog";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/pages/home/components/Footer";

export default function Blog() {
  const [activeCategory, setActiveCategory] = useState("sve");
  const [searchQuery, setSearchQuery] = useState("");

  const filteredPosts = blogPosts.filter((p) => {
    const matchCategory = activeCategory === "sve" || p.categorySlug === activeCategory;
    const matchSearch =
      !searchQuery ||
      p.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
      p.excerpt.toLowerCase().includes(searchQuery.toLowerCase());
    return matchCategory && matchSearch;
  });

  return (
    <main className="min-h-screen bg-white">
      <Navbar />

      <section className="pt-24 md:pt-32 pb-20 md:pb-28 bg-dark-50">
        <div className="w-full px-4 sm:px-6 lg:px-8 xl:px-12">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-12">
              <span className="inline-block text-dark-400 text-xs font-semibold uppercase tracking-widest mb-4">
                Blog
              </span>
              <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-dark-900 leading-tight mb-4">
                Stručni saveti i vodiči
              </h1>
              <p className="text-dark-500 text-base sm:text-lg max-w-2xl mx-auto">
                Najnovije informacije o bezbednosnim sistemima, kontroli pristupa, video nadzoru i pametnim rešenjima za vaš dom i biznis
              </p>
            </div>

            <div className="relative mb-10 max-w-md mx-auto">
              <i className="ri-search-line absolute left-4 top-1/2 -translate-y-1/2 text-dark-400"></i>
              <input
                type="text"
                placeholder="Pretražite članke..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="w-full pl-11 pr-5 py-3.5 rounded-xl border border-dark-200 bg-white text-dark-900 text-sm focus:outline-none focus:border-brand-400 focus:ring-2 focus:ring-brand-100 transition-all"
              />
            </div>

            <div className="flex flex-wrap justify-center gap-2 mb-12">
              {blogCategories.map((cat) => (
                <button
                  key={cat.slug}
                  onClick={() => setActiveCategory(cat.slug)}
                  className={`px-4 py-2 rounded-full text-sm font-medium transition-all whitespace-nowrap cursor-pointer ${
                    activeCategory === cat.slug
                      ? "bg-dark-900 text-white"
                      : "bg-white text-dark-600 border border-dark-200 hover:border-dark-300"
                  }`}
                >
                  {cat.name}
                  <span className="ml-1.5 text-xs opacity-60">({cat.count})</span>
                </button>
              ))}
            </div>

            {filteredPosts.length === 0 ? (
              <div className="text-center py-20">
                <div className="w-16 h-16 flex items-center justify-center mx-auto bg-dark-100 rounded-full mb-4">
                  <i className="ri-search-line text-dark-400 text-2xl"></i>
                </div>
                <h3 className="text-lg font-semibold text-dark-900 mb-2">Nema rezultata</h3>
                <p className="text-dark-400">Pokušajte sa drugim terminom pretrage</p>
              </div>
            ) : (
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
                {filteredPosts.map((post) => (
                  <article key={post.slug} className="bg-white rounded-2xl border border-dark-100 overflow-hidden transition-all duration-300 hover:-translate-y-2 group">
                    <Link to={`/blog/${post.slug}`} className="block">
                      <div className="aspect-[16/10] bg-dark-100 overflow-hidden relative">
                        <img
                          src={post.image}
                          alt={post.title}
                          className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
                          loading="lazy"
                        />
                        <span className="absolute top-4 right-4 bg-white/90 backdrop-blur-sm text-dark-800 text-xs font-medium px-3 py-1.5 rounded-full">
                          {post.category}
                        </span>
                      </div>
                      <div className="p-6">
                        <div className="flex items-center gap-3 text-xs text-dark-400 mb-3">
                          <span className="flex items-center gap-1">
                            <i className="ri-calendar-line"></i>
                            {post.date}
                          </span>
                          <span className="flex items-center gap-1">
                            <i className="ri-time-line"></i>
                            {post.readTime}
                          </span>
                        </div>
                        <h2 className="text-lg font-bold text-dark-900 mb-3 group-hover:text-brand-600 transition-colors line-clamp-2">
                          {post.title}
                        </h2>
                        <p className="text-dark-500 text-sm leading-relaxed line-clamp-2 mb-4">
                          {post.excerpt}
                        </p>
                        <div className="flex items-center gap-2 text-brand-600 text-sm font-semibold">
                          Pročitaj više
                          <i className="ri-arrow-right-line"></i>
                        </div>
                      </div>
                    </Link>
                  </article>
                ))}
              </div>
            )}
          </div>
        </div>
      </section>

      <Footer />
    </main>
  );
}